import React from 'react';
import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';




export default function ReadonlyBlockNotice({ title, description, notice }) {

  return (
    <div
      {...useBlockProps({ className: "readonly-block-notice" })}
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        background: "#fafafa",
        padding: "24px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        width: "100%",
      }}
    >
      <span style={{ display: "flex", alignItems: "center" }}>
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="6" y="12" width="28" height="16" rx="4" fill="#e2e8f0" />
          <circle cx="12" cy="20" r="3" fill="#3b82f6" />
          <circle cx="20" cy="20" r="3" fill="#3b82f6" />
          <circle cx="28" cy="20" r="3" fill="#3b82f6" />
        </svg>
      </span>
      <div>
        <strong
          style={{
            fontSize: "1.1em",
            color: "#222",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {title || __("Bloc non modifiable", "carousel-affiche")}
        </strong>
        <div style={{ color: "#666", marginTop: "4px" }}>
          {description || __("Bloc dynamique sur-mesure", "carousel-affiche")}
        </div>
        <div style={{ color: "#666", marginTop: "4px" }}>
          {notice ||
            __(
              "Ce bloc est non modifiable dans l’éditeur.",
              "carousel-affiche"
            )}
        </div>
      </div>
    </div>
  );
}
